// Mirrors ownsOrAdmin by email. A collaborator may read and comment only.
export function managesFeedbackPeople(item, me) {
  if (me?.admin === true) return true;
  if (!item || !me || typeof me.email !== 'string' || me.email === '') return false;
  if (typeof item.user_email !== 'string') return false;
  return me.email.toLowerCase() === item.user_email.toLowerCase();
}
